import { PrintsSlider } from '@theme/prints-slider';

/**
 * Recommended prints. Shopify's recommendation results (Related / Complementary)
 * are only available when the section is rendered through the Product
 * Recommendations route, so the cards can't be rendered on first paint. We fetch
 * this same section against that route (`?product_id=…&intent=related&limit=…`),
 * which populates the `recommendations` object and lets the Liquid render the
 * framed print cards inside `#recommended-cards`. The shared PrintsSlider base
 * handles the slider once the cards are swapped in.
 */
class RecommendedPrintsSection extends PrintsSlider {
  async load() {
    const { sectionId, url, productId, intent, limit } = this.dataset;

    // Without a product there's nothing to recommend. Reveal the placeholders in
    // the theme editor so the merchant can still style the section.
    if (!sectionId || !url || !productId) {
      if (this.designMode) this.revealPlaceholders();
      return;
    }

    const requestUrl = new URL(url, location.origin);
    requestUrl.searchParams.set('section_id', sectionId);
    requestUrl.searchParams.set('product_id', productId);
    if (intent) requestUrl.searchParams.set('intent', intent);
    if (limit) requestUrl.searchParams.set('limit', limit);

    let markup;
    try {
      const response = await fetch(requestUrl);
      if (!response.ok) return;
      markup = await response.text();
    } catch {
      return;
    }
    if (!markup) return;

    const cards = new DOMParser().parseFromString(markup, 'text/html').getElementById('recommended-cards');

    if (!cards || cards.children.length === 0) {
      // No recommendations — stay hidden for real visitors, reveal placeholders
      // in the theme editor so the section stays styleable.
      if (this.designMode) this.revealPlaceholders();
      return;
    }

    this.showCards(cards.children);
  }
}

if (!customElements.get('recommended-prints-section')) {
  customElements.define('recommended-prints-section', RecommendedPrintsSection);
}
